import { render, staticRenderFns } from "./TransferComment.vue?vue&type=template&id=5a591402&"
import script from "./TransferComment.vue?vue&type=script&lang=js&"
export * from "./TransferComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports